'use client'

import Image from 'next/image'

import { useImageError } from '@/app/lib/hooks/useImageError'

import type { FallbackImageProps } from './types'

/**
 * FallbackImage — `next/image` en modo `fill` que se oculta a sí misma si la
 * carga falla en el navegador (404, red caída, CORS...), dejando visible el
 * fondo de color placeholder del contenedor que la envuelve.
 *
 * Client Component: la detección de fallo de carga (`onError`) solo existe
 * en el navegador. Se aísla en este átomo hoja para que solo ella hidrate
 * JS — los componentes que la envuelven (`Poster`, `OfferBanner`,
 * `PromoBanner`, `Avatar`...) siguen siendo Server Component.
 */
export function FallbackImage({ src, alt, sizes, priority = false, className }: FallbackImageProps) {
  const { hasError, onError } = useImageError(src)

  if (hasError) return null

  return (
    <Image
      src={src}
      alt={alt}
      fill
      sizes={sizes}
      priority={priority}
      className={className}
      onError={onError}
    />
  )
}
